import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  retryButton: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.main,
  },
}));
